// ============================================================
// AssistantBar-Engine — Backend-Endpunkte + authentifizierte Fetches.
// 1:1 aus AssistantBar.js (Vanilla) hierher verschoben.
// ============================================================
// @ts-expect-error — core/auth.js ist reines JS ohne Typen
import { getToken } from '../../../core/auth.js';

// backend chat endpoint (key emn poshte backend ast)
// Relativ wie alle anderen Module: lokal geht das durch den Vite-/api-Proxy zum
// Dev-Backend — NIE absolut auf Produktion zeigen (sonst sendet lokales Entwickeln
// echte WhatsApp-/E-Mail-Nachrichten an echte Kunden).
export const VOICE_CHAT_URL = '/api/voice/chat';
export const VOICE_HISTORY_BASE = '/api/voice/history';
export const VOICE_TOKEN_URL = '/api/voice/token';
export const VOICE_OFFER_URL = '/api/voice/offer-draft';
export const VOICE_PREVIEW_BASE = '/api/voice/offer-preview';
export const VOICE_SEND_URL = '/api/voice/send-whatsapp';
export const VOICE_EMAIL_URL = '/api/voice/send-email';
export const VOICE_RUNTOOL_URL = '/api/voice/run-tool';

// Fehler-Detail lesbar machen — Backend-Fehler kommen teils als Objekt
// ({ code, message }), sonst stünde «[object Object]» in der Meldung.
export function errDetail(v: unknown): string {
  if (!v) return '';
  if (typeof v === 'string') return v;
  const m = (v as { message?: unknown }).message;
  if (m) return String(m);
  try { return JSON.stringify(v); } catch { return String(v); }
}

// ── history helpers (ba login token kar mikonand) ──
export async function authedFetch(url: string, opts: RequestInit = {}): Promise<Response> {
  const token = getToken();
  return fetch(url, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: 'Bearer ' + token } : {}),
      ...((opts.headers as Record<string, string>) || {}),
    },
  });
}

// ── tool execution (function call -> webhook) ──
// Zeitlimit für Werkzeug-Aufrufe: Gemini Live wartet blockierend auf die
// functionResponse. Hing der fetch (Netz weg, Backend klemmt), bekam das
// Modell NIE eine Antwort und die Sitzung blieb für immer stumm — Mohammads
// «geht etwas erledigen und kommt nicht wieder». Lieber nach 25 s ein
// ehrliches error-Ergebnis, das das Modell aussprechen kann.
export const TOOL_TIMEOUT_MS = 25000;
export function toolFetch(url: string, opts: RequestInit = {}): Promise<Response> {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), TOOL_TIMEOUT_MS);
  return authedFetch(url, { ...opts, signal: ctrl.signal }).finally(() => clearTimeout(timer));
}
